import { Stack, Typography } from '@mui/material';
import { RadioInput } from 'Components/HookFormInputs/RadioInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useFormContext } from 'react-hook-form';

const CaregiverViaInstitute = () => {
  const { watch } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  return (
    <Stack gap='20px' role='radiogroup' component='fieldset'>
      <legend>{dictionary.caregiverViaInstitute}</legend>
      <Typography variant='body2'>
        {dictionary.caregiverViaInstitute}
      </Typography>
      <RadioInput
        options={[
          { value: null, label: dictionary.all },
          {
            value: true,
            label: dictionary.viaInstitute,
          },
        ]}
        name={'instituteId'}
        externalValue={watch('instituteId') || ''}
      />
    </Stack>
  );
};

export default CaregiverViaInstitute;
